import { Input } from './Input';

export { Input };

export default Input;
